// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2duU8","validationTips":"StatementDescriptor_validationTips__1zqDM"};